// extracted by mini-css-extract-plugin
export default {"containerr":"fhkOu","mobile":"AzRUI","loader":"n6roj","button":"umhMq","loading":"N6cDS","full":"h98+1","rounded":"czRHg"};